/**
 * The playback pair shared by every section built on the `content-tabs` engine (`content-tabs`,
 * `tabbed-columns`) — asked for by the founder on 18/09/2026: « je veux ajouter la config de auto play
 * and mute sound to the component ».
 *
 * ONE definition, imported by both schemas, for the same reason `headingHighlightFields` is shared: two
 * copies would be two field ids, two labels, and two pairs of dictionary keys to keep in step across seven
 * languages — and the day they drift, the guard that compares each locale to French goes red for a reason
 * nobody can see from the section they were editing.
 *
 * They are SECTION settings although the clip belongs to a tab (or, in `tabbed-columns`, to a card): how a
 * section's videos behave is one decision for the whole widget, like every other knob in these two — a row
 * where one card plays silently and its neighbour asks to be clicked is not a row a seller meant to build.
 *
 * The values do not reach the `<video>` through the markup; the section prints them on the widget root and
 * `contentTabsInit` applies them (see the PLAYBACK POLICY note there). Both default to the behaviour the
 * sections already had, so no existing page changes.
 */
export const tabVideoFields = [
    {
        id: 'videoAutoplay',
        type: 'checkbox',
        label: 'Play videos automatically',
        group: 'Media',
        default: true,
        info: 'The visible tab plays its clip on its own, looping, like a moving picture. Turn it off to show the player controls and let the visitor start it.',
    },
    {
        id: 'videoMuted',
        type: 'checkbox',
        label: 'Mute the sound',
        group: 'Media',
        default: true,
        info: 'A browser never starts a clip with sound on its own, so turning this off also shows the player controls — otherwise the visitor would face a still frame with no way in.',
    },
];
//# sourceMappingURL=tabVideo.js.map